import React from 'react';
import Slide from '@material-ui/core/Slide';
import Grow from '@material-ui/core/Grow';

import SnackbarManager from '../Notification/components/Snackbar/manager';
import NotificationManager from '../Notification';
import { isEmptyString } from '../../utils';

export default class UIUtils extends React.PureComponent {

    constructor(props) {
        super(props);
        this._notificationManager = React.createRef();
        this._snackbarManager = React.createRef();
    }

    showNotification = (content, props) => this._notificationManager.current.enqueMessage(content, props);

    showSnack = (content, props) => this._snackbarManager.current.enqueMessage(content, props);

    render = () => <>
        <NotificationManager ref={this._notificationManager} />
        <SnackbarManager ref={this._snackbarManager} />
    </>;

}

const utilsRef = React.createRef();

export { utilsRef };

export const showNotification = (content, props) => utilsRef.current.showNotification(content, props);

// Custom Snack, content should be a node
export const showSnack = (content, props) => utilsRef.current.showSnack(content, { ...props, type: 'custom' });

export const showInfoSnack = (content, props) => utilsRef.current.showSnack(content, { ...props, type: 'info' });

export const showSuccessSnack = (content, props) => utilsRef.current.showSnack(content, { ...props, type: 'success' });

export const showWarningSnack = (content, props) => utilsRef.current.showSnack(content, { ...props, type: 'warning' });

export const showErrorSnack = (content, props) => utilsRef.current.showSnack(content, { ...props, type: 'error' });

export const handleNetworkError = error => {
    let msg;
    if (typeof error === 'string') msg = error;
    else if (error != null && typeof error.message === 'string') msg = error.message;
    else if (error != null && typeof error.error === 'string') msg = error.error;
    !isEmptyString(msg) && showErrorSnack(msg);
};

export const SlideTransition = React.forwardRef((props, ref) => <Slide ref={ref} {...props} />);

export const GrowTransition = React.forwardRef((props, ref) => <Grow ref={ref} {...props} />);